import React from "react";

/**
 * Daily / monthly / yearly diesel & maintenance record grids for VM overview.
 */
export default function VmOverviewRecordTables({
  S,
  fmtInr,
  filterMode,
  periodTitle,
  recordsSectionTitle,
  maintSectionTitle,
  dieselRecordGrid,
  dieselNotFilled,
  maintenanceRecordGrid,
}) {
  return (
    <>
      <div style={S.section}>{recordsSectionTitle}</div>
      <div style={S.panel}>
        <div style={{ ...S.tableScroll, maxHeight: 420 }}>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>Vehicle</th>
                <th style={S.th}>Driver</th>
                <th style={S.th}>Owner</th>
                <th style={S.th}>Station</th>
                <th style={S.th}>Ltrs</th>
                <th style={S.th}>Amount</th>
                <th style={S.th}>Time</th>
                <th style={S.th}>Open KM</th>
                <th style={S.th}>Close KM</th>
                <th style={S.th}>Total KM</th>
                <th style={S.th}>Exp KM</th>
                <th style={S.th}>KM diff</th>
                <th style={S.th}>KM/L</th>
                <th style={S.th}>Status</th>
              </tr>
            </thead>
            <tbody>
              {dieselRecordGrid.length === 0 && filterMode !== "day" ? (
                <tr>
                  <td style={S.td} colSpan={14}>
                    No diesel records in {periodTitle}.
                  </td>
                </tr>
              ) : null}
              {dieselRecordGrid.map((r) => (
                <tr key={r.id} style={{ background: "#f6fff6" }}>
                  <td style={S.td}>
                    <b>{r.vehicleNumber}</b>
                  </td>
                  <td style={S.td}>{r.driverName}</td>
                  <td style={S.td}>{r.ownerName}</td>
                  <td style={S.td}>{r.pumpName}</td>
                  <td style={S.td}>{r.volume}</td>
                  <td style={S.td}>{fmtInr(r.amount)}</td>
                  <td style={S.td}>{r.time}</td>
                  <td style={S.td}>{r.startKm}</td>
                  <td style={S.td}>{r.endKm}</td>
                  <td style={S.td}>{r.totalKm}</td>
                  <td style={S.td}>{r.expectKm}</td>
                  <td
                    style={{
                      ...S.td,
                      fontWeight: 700,
                      color: Number(r.kmDiff) >= 0 ? "#2e7d32" : "#c62828",
                    }}
                  >
                    {r.kmDiff !== "—"
                      ? Number(r.kmDiff) >= 0
                        ? `+${r.kmDiff}`
                        : r.kmDiff
                      : "—"}
                  </td>
                  <td style={S.td}>{r.actualKmL}</td>
                  <td style={S.td}>
                    <span style={S.badge("ok")}>{r.status}</span>
                  </td>
                </tr>
              ))}
              {filterMode === "day"
                ? dieselNotFilled.map((r) => (
                    <tr key={`empty-${r.vehicleNumber}`} style={{ background: "#fff8f8" }}>
                      <td style={S.td}>
                        <b>{r.vehicleNumber}</b>
                      </td>
                      <td style={S.td} colSpan={12}>
                        <span style={S.badge("bad")}>Not filled</span>
                        <span style={{ marginLeft: 8, color: "#666" }}>
                          {r.ownerName} · {r.vehicleType}
                        </span>
                      </td>
                      <td style={S.td}>
                        <span style={S.badge("warn")}>{r.status}</span>
                      </td>
                    </tr>
                  ))
                : null}
            </tbody>
          </table>
        </div>
      </div>

      <div style={S.section}>{maintSectionTitle}</div>
      <div style={S.panel}>
        <div style={{ ...S.tableScroll, maxHeight: 320 }}>
          <table style={S.table}>
            <thead>
              <tr>
                <th style={S.th}>Date</th>
                <th style={S.th}>Vehicle</th>
                <th style={S.th}>Type</th>
                <th style={S.th}>Amount</th>
                <th style={S.th}>Workshop</th>
                <th style={S.th}>Driver</th>
                <th style={S.th}>Next service</th>
              </tr>
            </thead>
            <tbody>
              {maintenanceRecordGrid.length === 0 ? (
                <tr>
                  <td style={S.td} colSpan={7}>
                    No maintenance records in {periodTitle}.
                  </td>
                </tr>
              ) : (
                maintenanceRecordGrid.map((r) => (
                  <tr key={r.id}>
                    <td style={S.td}>{r.dateKey}</td>
                    <td style={S.td}>
                      <b>{r.vehicleNumber}</b>
                    </td>
                    <td style={S.td}>{r.maintenanceType}</td>
                    <td style={S.td}>{fmtInr(r.amount)}</td>
                    <td style={S.td}>{r.workshop}</td>
                    <td style={S.td}>{r.driver}</td>
                    <td style={S.td}>{r.nextServiceDate}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
